import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  getPartnerIdentityHeadersForClaims,
  IClaimLandingRequestParams,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getClaimLandingDetails = async (
  data: IClaimLandingRequestParams
): Promise<any> => {
  try {
    const { partner, bookingId, partnerBookingId, headers, cmp, query, dvid } =
      data || {};
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      ...(partnerBookingId ? { partnerBookingId } : {}),
      ...query,
    };

    const urlParams = setURLQueryParams(params);
    const identityHeaders = getPartnerIdentityHeadersForClaims({
      cookie: headers?.cookie,
      partner,
      query,
    });

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.CLAIM_LANDING}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp, dvid, ...identityHeaders },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching claim landing details", { error });
    throw error;
  }
};
